import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import type { TModalsContext } from '@/contexts/ModalsProvider/types';

import { HF_ROUTES } from '@/config/routes';
import { EStationSetupStep } from '@/config/station';

import { STATION_SETUP_STEPS } from '@/components/createStation/steps';
import { GenericModal } from '@/components/modal/GenericModal';
import { Stepper } from '@/components/stepper/Stepper';

import type { TCreateStationForm } from '@/types/station';

import { GenericModalClose } from '../modal/GenericModalClose';
import { styles } from './CreateStation.styles';

type TCreateStationProps = TModalsContext & {
  onSuccess: () => void;
};

export const CreateStation = ({ close, lock, onSuccess }: TCreateStationProps) => {
  const { t } = useTranslation();
  const history = useHistory();

  const onFinish = ({ result }: TCreateStationForm) => {
    onSuccess();
    // The station was created, and station data marked old, by `useCreateStation` (W3) in the
    // `SystemConnection` step; this only closes the wizard and opens the new station.

    const path = generatePath(HF_ROUTES.stationEntity, { id: result.id });
    history.push(path);

    close('stations.create');
  };
  const onClose = () => {
    // eslint-disable-next-line no-alert
    if (window.confirm(t('stationSetup.sureYouWantToLeave'))) {
      close('stations.create');
    }
  };

  useEffect(() => {
    lock('stations.create', () =>
      // ToDo: Clear that with someone - use custom submit or just close the modal without any
      // eslint-disable-next-line no-alert
      window.confirm(t('stationSetup.sureYouWantToLeave')),
    );
  }, [lock, t]);

  return (
    <GenericModal sx={styles.modal}>
      <GenericModalClose onClick={onClose} />
      <Stepper
        sidePaneTitle="stationSetup.sidePaneTitle"
        step={EStationSetupStep.STATION_TYPE}
        steps={STATION_SETUP_STEPS}
        onFinish={onFinish}
        styles={styles}
      />
    </GenericModal>
  );
};
